import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import logo from '@/assets/images/lincpay-logo.png';

const SOCIAL_LINKS = [
    {
        name: 'LinkedIn',
        url: 'https://www.linkedin.com/company/lincpay07/',
        icon: (
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9h4v12H3zM9.5 9H13v1.64h.05c.5-.9 1.7-1.85 3.5-1.85 3.74 0 4.45 2.35 4.45 5.4V21H17v-4.9c0-1.17-.02-2.68-1.63-2.68-1.64 0-1.87 1.27-1.87 2.6V21H9.5z" />
            </svg>
        ),
    },
    {
        name: 'X (Twitter)',
        url: 'https://x.com/LincPay07',
        icon: (
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M17.53 3H20.5l-6.48 7.4L21.75 21h-6.2l-4.86-6.36L5.1 21H2.13l6.93-7.92L2.5 3h6.36l4.4 5.82L17.53 3Zm-1.09 16.2h1.65L7.6 4.7H5.83z" />
            </svg>
        ),
    },
    {
        name: 'Facebook',
        url: 'https://www.facebook.com/share/1BULEcyivZ/',
        icon: (
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0 0 22 12Z" />
            </svg>
        ),
    },
    {
        name: 'YouTube',
        url: 'https://www.youtube.com/@Lincpay',
        icon: (
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M23 12s0-3.2-.4-4.7a2.5 2.5 0 0 0-1.76-1.77C19.27 5.1 12 5.1 12 5.1s-7.27 0-8.84.43A2.5 2.5 0 0 0 1.4 7.3C1 8.8 1 12 1 12s0 3.2.4 4.7a2.5 2.5 0 0 0 1.76 1.77C4.73 18.9 12 18.9 12 18.9s7.27 0 8.84-.43A2.5 2.5 0 0 0 22.6 16.7c.4-1.5.4-4.7.4-4.7Zm-13.2 3.02V8.98L15.2 12z" />
            </svg>
        ),
    },
    {
        name: 'Instagram',
        url: 'https://www.instagram.com/lincpaysolutions',
        icon: (
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3.5" y="3.5" width="17" height="17" rx="5" stroke="currentColor" strokeWidth="1.7" />
                <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.7" />
                <circle cx="17.2" cy="6.8" r="1.15" fill="currentColor" />
            </svg>
        ),
    },
];

const PLATFORMS_LINKS = [
    { label: 'CBSNexora', href: 'https://lincpay.in/platforms/cbsnexora', isExternal: true },
    { label: 'XpressLinc', href: '/xpresslinc', isExternal: false },
    { label: 'LincShield', href: 'https://lincpay.in/platforms/lincshield', isExternal: true },
    { label: 'LincAI', href: 'https://lincpay.in/platforms/lincai', isExternal: true },
];

const SOLUTIONS_LINKS = [
    { label: 'RuPay Tap on Phone', href: 'https://lincpay.in/rupay-tap-on-phone', isExternal: true },
    { label: 'Banking Solutions', href: 'https://lincpay.in/solutions/banking-solutions', isExternal: true },
    { label: 'Digital Payments', href: '/xpresslinc', isExternal: false },
    { label: 'Merchant Acceptance', href: '/onboarding-demos', isExternal: false },
    { label: 'Compliance & Risk', href: 'https://lincpay.in/solutions/compliance-risk', isExternal: true },
];

const TECH_LINKS = [
    { label: 'Platform Architecture', href: 'https://lincpay.in/technology/platform-architecture', isExternal: true },
    { label: 'Security Architecture', href: 'https://lincpay.in/technology/security-architecture', isExternal: true },
    { label: 'Compliance & Certifications', href: 'https://lincpay.in/technology/compliance', isExternal: true },
    { label: 'API & Integration', href: 'https://lincpay.in/technology/api-integrations', isExternal: true },
];

const COMPANY_LINKS = [
    { label: 'About LincPay', href: 'https://lincpay.in/company/about', isExternal: true },
    { label: 'Why LincPay', href: 'https://lincpay.in/company/why-lincpay', isExternal: true },
    { label: 'Careers', href: 'https://lincpay.in/company/careers', isExternal: true },
    { label: 'Contact Sales', href: '/book-appointment', isExternal: false },
];

const RESOURCES_LINKS = [
    { label: 'Blog', href: 'https://lincpay.in/resources/blog', isExternal: true },
    { label: 'Whitepapers', href: 'https://lincpay.in/resources/whitepapers', isExternal: true },
    { label: 'Banking Glossary', href: 'https://lincpay.in/resources/glossary', isExternal: true },
    { label: 'Brochures', href: 'https://lincpay.in/resources/brochures', isExternal: true },
];

const LEGAL_LINKS = [
    { label: 'Privacy Policy', href: 'https://lincpay.in/legal/privacy-policy' },
    { label: 'Terms of Use', href: 'https://lincpay.in/legal/terms-of-use' },
    { label: 'Cookie Policy', href: 'https://lincpay.in/legal/cookie-policy' },
    { label: 'Disclaimer', href: 'https://lincpay.in/legal/disclaimer' },
];

export default function Footer() {
    return (
        <footer className="relative bg-[#020617] border-t border-slate-800 overflow-hidden text-white">
            {/* Background Decorative Mesh - High Density */}
            <div
                className="absolute inset-0 opacity-[0.04] pointer-events-none -z-10"
                style={{
                    backgroundImage: `radial-gradient(circle at 2px 2px, #475569 1px, transparent 0)`,
                    backgroundSize: '24px 24px',
                }}
            />

            <div className="container px-4 md:px-6 lg:px-8 mx-auto pt-14 pb-10">
                {/* Top Section: Brand + 5 Navigation Columns */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 pb-12 border-b border-slate-800/80">
                    {/* Brand Info & Socials (4 Columns on Desktop) */}
                    <div className="lg:col-span-4 flex flex-col items-start gap-4 pr-0 lg:pr-6">
                        <Link to="/" className="inline-flex items-center gap-3">
                            <div className="bg-white rounded-lg px-3 py-1.5 shadow-sm">
                                <img
                                    src={logo}
                                    alt="LincPay Logo"
                                    className="h-7 w-auto object-contain"
                                />
                            </div>
                            <div className="h-4 w-px bg-slate-700" />
                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                                Digital Ecosystem
                            </span>
                        </Link>

                        <p className="text-xs text-slate-400 font-normal leading-relaxed max-w-sm mt-1">
                            Banking & Payments Infrastructure for the Digital Financial Ecosystem. Enabling banks, NBFCs, and fintechs to build secure, scalable, and compliant digital services.
                        </p>

                        {/* NPCI-Certified Technology Badge */}
                        <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-950/40 px-3 py-1 text-xs font-medium text-emerald-300">
                            <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" />
                            <span>NPCI-Certified Technology</span>
                        </div>

                        {/* Social Links (Matching https://lincpay.in/) */}
                        <div className="flex items-center gap-2.5 mt-2">
                            {SOCIAL_LINKS.map((item) => (
                                <a
                                    key={item.name}
                                    href={item.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={item.name}
                                    title={item.name}
                                    className="flex h-9 w-9 items-center justify-center rounded-lg border border-slate-800 bg-slate-900/70 text-slate-400 transition-all duration-200 hover:border-primary hover:bg-primary/20 hover:text-white hover:scale-105 shadow-sm"
                                >
                                    {item.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Columns (8 Columns on Desktop, 5 sub-columns) */}
                    <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 sm:gap-8">
                        {/* Platforms */}
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-300">
                                Platforms
                            </h2>
                            <ul className="space-y-2">
                                {PLATFORMS_LINKS.map((link) => (
                                    <li key={link.label}>
                                        {link.isExternal ? (
                                            <a
                                                href={link.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.href}
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Solutions */}
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-300">
                                Solutions
                            </h2>
                            <ul className="space-y-2">
                                {SOLUTIONS_LINKS.map((link) => (
                                    <li key={link.label}>
                                        {link.isExternal ? (
                                            <a
                                                href={link.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.href}
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Technology & Trust */}
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-300">
                                Tech & Trust
                            </h2>
                            <ul className="space-y-2">
                                {TECH_LINKS.map((link) => (
                                    <li key={link.label}>
                                        <a
                                            href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Company */}
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-300">
                                Company
                            </h2>
                            <ul className="space-y-2">
                                {COMPANY_LINKS.map((link) => (
                                    <li key={link.label}>
                                        {link.isExternal ? (
                                            <a
                                                href={link.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.href}
                                                className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                            >
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Resources */}
                        <div className="flex flex-col gap-3">
                            <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-300">
                                Resources
                            </h2>
                            <ul className="space-y-2">
                                {RESOURCES_LINKS.map((link) => (
                                    <li key={link.label}>
                                        <a
                                            href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-xs sm:text-[13px] text-slate-400 transition-colors hover:text-white"
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Status Bar & Compliance Ribbon */}
                <div className="py-6 border-b border-slate-800/80 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs leading-relaxed text-slate-400 max-w-3xl">
                        LincPay solutions are aligned with industry and regulatory expectations for financial institutions, including NPCI standards, RBI guidelines, PCI-DSS (applicable card products), and CERT-In-aligned practices.
                    </p>

                    <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-950/40 border border-emerald-500/30 shrink-0">
                        <div className="h-2 w-2 bg-emerald-500 rounded-full animate-pulse shadow-[0_0_8px_rgba(16,185,129,0.8)]" />
                        <span className="text-xs font-semibold text-emerald-400 font-mono tracking-wide">
                            API Uptime: 99.998%
                        </span>
                    </div>
                </div>

                {/* Bottom Legal & Copyright Bar */}
                <div className="pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-400">
                    <p>© 2026 LincPay Solutions Private Limited. All rights reserved.</p>

                    <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
                        {LEGAL_LINKS.map((link) => (
                            <li key={link.label}>
                                <a
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-xs text-slate-400 transition-colors hover:text-white"
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    );
}
